import InputText from './input-text.js';
import styles from './input-date.css' assert {type: 'css'};

/**
 * @element inv-input-date
 *
 * @class InputDate
 * @extends InputText
 * @classdesc InputDate component that extends InputText and adds date validation
 *
 * @property {String} type - type of input
 * @property {String} min - minimum date
 * @property {String} max - maximum date
 */

export default class InputDate extends InputText {
    constructor() {
        super();
        this.type = 'date';
        this.min = null;
        this.max = null;
    }

    getStyleSheets() {
        return [...super.getStyleSheets(), styles];
    }

    static get properties() {
        return {
            ...super.properties,
            type: {
                type: String,
            },
            min: {
                type: String,
            },
            max: {
                type: String,
            },
        };
    }

    setMinAndMax() {
        const input = this.#input;
        if (this.min) {
            input.setAttribute('min', this.min);
        }
        if (this.max) {
            input.setAttribute('max', this.max);
        }
    }

    get #input() {
        return this.renderRoot?.querySelector(`input[name=${this.name}]`);
    }

    firstUpdated() {
        // Si el navegador no soporta el tipo de input month, lo cambiamos a date
        const input = this.#input;
        if (input) {
            if(this.type==='month' && input.type  === 'text'){
                input.type='date';
            }
        }
        this.setMinAndMax();
    }
}

InputDate.register();
